var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('loader'):_c('div',{staticClass:"container container__report",domProps:{"innerHTML":_vm._s(_vm.reportContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }